import * as React from "react";
import DeletePanel from "../../components/CustomDelete/DeletePanel";
import strings from "../../config/localization";
import { useDeleteResourceMutation } from "../../services/appln";

export default function DeleteResource(props: any): any {
  return (
    <DeletePanel
      useIcon={true}
      deleteMutation={useDeleteResourceMutation}
      deleteArgs={{ id: props.id }}
      buttonLabel={strings.delete}
      confirmationDialogTitle={strings.deleteResourceTitle}
      confirmationDialogMsg={strings.deleteResourceConfirmation}
      errorDialogTitle={strings.deleteResourceFailedTitle}
      errorDialogMsg={strings.deleteResourceFailedMsg}
    />
  );
}
